import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useTheme } from '@mui/material';

import Stack from '@mui/material/Stack';
import Link from '@mui/material/Link';
import SvgIcon from '@mui/material/SvgIcon';
import Typography from '@mui/material/Typography';
import LayoutServicePage from 'components/mui/Layouts/LayoutServicePage';
import { DeviceLogo } from 'pages/notSupported/StyledComponents';

import IpadIcon from './icons/ipad.png';

import { ReactComponent as ChromeIcon } from './icons/chromeIcon.svg';

const NotSupported = () => {
  const { labelOptions } = useTheme();

  return (
    <LayoutServicePage sx={{ textAlign: 'center', alignItems: 'center' }}>
      <img src={labelOptions.logotype.src} alt="logo" style={{ width: 460, height: 116, margin: '60px auto 0' }} />
      <Stack gap={0} flex={1} justifyContent="center" alignItems="center" component="main">
        <DeviceLogo src={IpadIcon} />
        <Typography variant="h4" sx={{ mb: 3 }}>
          <FormattedMessage id="notSupportedPage.ipadMessage" defaultMessage="iPad is not supported" />
        </Typography>

        <Typography component="div" sx={{ color: 'text.secondary', mb: 3 }}>
          <Stack direction="row" alignItems="center" justifyContent="center" flexWrap="wrap" spacing={0.5}>
            <FormattedMessage
              id="notSupportedPage.description.title3"
              defaultMessage="Please, access application from Windows, Mac or Linux"
            />
            <SvgIcon sx={{ fontSize: '25px' }} component={ChromeIcon} inheritViewBox />
            <Link href="https://www.google.com/chrome/" target="_blank" rel="noopener noreferrer">
              Chrome
            </Link>
            <FormattedMessage id="notSupportedPage.description.title2" defaultMessage="internet browser." />
          </Stack>
        </Typography>

        <Typography
          variant="h6"
          sx={{ color: 'text.secondary', maxWidth: 400, fontWeight: 'normal', textAlign: 'center' }}
        >
          <FormattedMessage
            id="notSupportedPage.description.message"
            defaultMessage="We are working on adding support for other browsers in the near future."
          />
        </Typography>
      </Stack>
    </LayoutServicePage>
  );
};

export default NotSupported;
